import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Header, Title, Footer } from '@calendly/ui/components/popup'

import { HelpCenterLink } from 'components/scheduled_events/event/sidebar/report/help_center_link'

import {
  Message,
  ConfirmationIcon
} from './styles'

export const ReportSuccessModal = ({ onClose }) => (
  <Popup
    onClose={onClose}
  >
    <Header>
      <ConfirmationIcon />
      <Title>
        {I18n.t('publisher.abuse_reporting.success_modal.title')}
      </Title>
      <Message>
        {HtmlParser(I18n.t('publisher.abuse_reporting.success_modal.message'), { HelpCenterLink })}
      </Message>
    </Header>
    <Footer>
      <Button
        wide
        decoration="primary"
        onClick={onClose}
      >
        {I18n.t('publisher.action.ok')}
      </Button>
    </Footer>
  </Popup>
)
